import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { AgencyGuidanceDocPage, parseGuidanceSearch, preferredGuidanceLanguage, rememberGuidanceLanguage } from '@/features/agency';
import type { GuidanceLanguage } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

/** Docs are drawn in a shadow root, which ignores @font-face, so their fonts load from the document head. */
const GUIDANCE_DOC_FONTS =
  'https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,800&family=Be+Vietnam+Pro:ital,wght@0,400;0,500;0,600;0,700;1,400&family=JetBrains+Mono:wght@500;700&display=swap';

export const Route = createFileRoute('/_auth/agency/guidance/$slug')({
  validateSearch: parseGuidanceSearch,
  component: AgencyGuidanceDocRoute,
});

function AgencyGuidanceDocRoute() {
  const { slug } = Route.useParams();
  const { lang } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onLanguageChange = (next: GuidanceLanguage) => {
    rememberGuidanceLanguage(next);
    void navigate({ search: { lang: next }, replace: true });
  };
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Guidance')}</title>
        <link rel="stylesheet" href={GUIDANCE_DOC_FONTS} />
      </Helmet>
      <AgencyGuidanceDocPage slug={slug} language={lang ?? preferredGuidanceLanguage()} onLanguageChange={onLanguageChange} />
    </>
  );
}
